<template>
  <div>
    <el-card>
      <div slot="header">Your Efficiency Score</div>
      <el-progress type="circle" :percentage="25"></el-progress>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'EfficiencyScore',
  };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/EfficiencyScore.vue